import { render, staticRenderFns } from "./ViInbox.vue?vue&type=template&id=256f7f9c"
import script from "./ViInbox.vue?vue&type=script&lang=js"
export * from "./ViInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports